var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.524a3.731 3.731 0 0 1-3.726 3.726H5V7.492a3.731 3.731 0 0 1 3.726-3.726H29v14.758Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.763 5.012a2.67 2.67 0 0 0-2.67 2.67v2.773h3.77c.088 0 .19 0 .264.015.851.044 1.482.484 1.482 1.247 0 .601-.426 1.114-1.218 1.217v.03c.866.058 1.526.542 1.526 1.29 0 .807-.734 1.335-1.702 1.335h-4.137v5.428h3.917a2.67 2.67 0 0 0 2.67-2.67V5.012h-3.902Z",
    fill: "url(#jcb_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.399 14.739h1.54c.022 0 .059-.004.095-.008.037-.003.074-.007.096-.007a.687.687 0 0 0 .543-.69.712.712 0 0 0-.543-.689c-.044-.015-.132-.015-.191-.015h-1.54v1.409Z",
    fill: "url(#jcb_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.939 11.262a.624.624 0 0 1 .543.63c0 .353-.25.587-.543.631-.015.015-.103.015-.147.015H22.4v-1.29h1.393c.024 0 .058.004.087.008a.55.55 0 0 0 .06.006Z",
    fill: "url(#jcb_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 5.012a2.67 2.67 0 0 0-2.67 2.67v6.587c.748.367 1.526.602 2.303.602.924 0 1.423-.558 1.423-1.32v-3.11h2.289v3.095c0 1.203-.748 2.186-3.286 2.186-1.54 0-2.744-.338-2.744-.338v5.619h3.917a2.67 2.67 0 0 0 2.67-2.67V5.013H9.005Z",
    fill: "url(#jcb_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.384 5.012a2.67 2.67 0 0 0-2.67 2.67v3.492c.675-.572 1.848-.94 3.74-.851 1.013.044 2.098.323 2.098.323v1.13a5.08 5.08 0 0 0-2.024-.588c-1.438-.102-2.303.602-2.303 1.834 0 1.247.865 1.951 2.303 1.834.836-.059 1.482-.323 2.024-.587v1.13s-1.07.279-2.097.323c-1.893.088-3.066-.28-3.741-.851v6.161h3.917a2.67 2.67 0 0 0 2.67-2.67V5.012h-3.917Z",
    fill: "url(#jcb_svg__e)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__a",
    x1: 21.09,
    y1: 11.89,
    x2: 27.683,
    y2: 11.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__b",
    x1: 21.09,
    y1: 11.89,
    x2: 27.683,
    y2: 11.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__c",
    x1: 21.09,
    y1: 11.89,
    x2: 27.683,
    y2: 11.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__d",
    x1: 6.332,
    y1: 13.008,
    x2: 13.026,
    y2: 13.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__e",
    x1: 13.676,
    y1: 13.008,
    x2: 20.177,
    y2: 13.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
};
export default SvgJcb;